import { render, staticRenderFns } from "./CameraSite.vue?vue&type=template&id=087d0f68&scoped=true"
import script from "./CameraSite.vue?vue&type=script&lang=js"
export * from "./CameraSite.vue?vue&type=script&lang=js"
import style0 from "./CameraSite.vue?vue&type=style&index=0&id=087d0f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d0f68",
  null
  
)

export default component.exports